import { ShippingInfo } from "../../Interfaces/ShippingInfo";
import { usePopup } from "../Popup/PopupContext";
import PopupModel from "../Popup/PopupModel";
import { getFormattedInputAddress } from "./ShippingAddress";

export const handleShippingErrorPopup = (
  shippingInfo: ShippingInfo,
  errors: string[],
  showPopup: (
    header: string,
    body: React.ReactNode,
    buttons: { label: string; onClick: () => void }[],
    width?: string
  ) => void
) => {
  const errorList = (
    <ul>
      {errors.map((err, index) => (
        <li key={index}>{err}</li>
      ))}
    </ul>
  );

  const shippingErrorPopup = new PopupModel(
    "Shipping - Error", // header
    (
      <div>
        <strong>Invalid address was inputted</strong>
        {getFormattedInputAddress(shippingInfo)}
        <strong>due to the following:</strong>
        {errorList}
      </div> //body
    ),
    [],
    "40vw" //width
  );

  showPopup(
    shippingErrorPopup.header,
    shippingErrorPopup.body,
    shippingErrorPopup.buttons,
    shippingErrorPopup.width
  );
};

export const handleShippingWarningPopup = (
  shippingInfo: ShippingInfo,
  warnings: string[],
  currentAddress: ShippingInfo,
  setShippingInfo: (shipping: ShippingInfo) => void,
  showPopup: (
    header: string,
    body: React.ReactNode,
    buttons: { label: string; onClick: () => void }[],
    width?: string
  ) => void,
  hidePopup: () => void
) => {
  const warningsList = (
    <ul>
      {warnings.map((warning, index) => (
        <li key={index}>{warning}</li>
      ))}
    </ul>
  );
  let formattedAddress;
  if (!currentAddress) {
    formattedAddress = <div> N/A </div>;
  } else {
    formattedAddress = (
      <div style={{ marginTop: "10px", marginBottom: "10px" }}>
        <strong>The following modified address was found:</strong>
        <div>{currentAddress.street_address}</div>
        {currentAddress.apt_suite && <div>{currentAddress.apt_suite}</div>}
        <div>
          {currentAddress.city}, {currentAddress.state}{" "}
          {currentAddress.zip_code}
        </div>
      </div>
    );
  }
  const shippingWarningPopup = new PopupModel(
    "Shipping - Warning", // header
    (
      <div>
        <strong>The provided original address</strong>
        {getFormattedInputAddress(shippingInfo)}
        <strong> may not be correct for the following reasons: </strong>
        {warningsList}
        {formattedAddress}
      </div> //body
    ),
    [
      {
        label: "Use Modified",
        onClick: () => {
          setShippingInfo(currentAddress);
          hidePopup();
        },
      },
      // right now must use the modified address current logic doesnt allow to bypass it
      // {
      //   label: "Use Original",
      //   onClick: () => {
      //     hidePopup();
      //   },
      // },
    ],
    "40vw" //width
  );

  showPopup(
    shippingWarningPopup.header,
    shippingWarningPopup.body,
    shippingWarningPopup.buttons,
    shippingWarningPopup.width
  );
};
